<oo-loading-container [status]="state.status">
  <ng-template>
    <oo-list-header title="Standings"></oo-list-header>

    <mat-card appearance="outlined">
      <mat-card-content>
        @if (state.standings.length) {
          <mat-list>
            @for (standing of state.standings; track standing; let index = $index) {
              <mat-list-item>
                <img
                  [ngSrc]="standing.imageUrl ? standing.imageUrl : 'https://ui-avatars.com/api/?name=' + standing.firstName + '+' + standing.lastName"
                  height="40"
                  matListItemAvatar
                  width="40">
                <div class="oo-row-content" matListItemTitle>
                  <span class="oo-place">{{ index + 1 }}.</span>
                  <span class="oo-username-cell">{{ standing.firstName }} {{ standing.lastName }}</span>
                  <span>{{ standing.score }}</span>
                </div>
              </mat-list-item>
            }
          </mat-list>
        }
        @if (!state.standings.length) {
          <div>
            No closed bettings yet
          </div>
        }
      </mat-card-content>
    </mat-card>
  </ng-template>
</oo-loading-container>
